export const FOLLOWED_PLACES_STORAGE_KEY = "protea.followed-place-ids";

type StorageLike = Pick<Storage, "getItem" | "setItem">;

const defaultStorage: StorageLike | null = (() => {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
})();

export const loadFollowedPlaceIds = (storage: StorageLike | null = defaultStorage): string[] => {
  if (!storage) return [];

  try {
    const rawValue = storage.getItem(FOLLOWED_PLACES_STORAGE_KEY);
    if (!rawValue) return [];
    const parsed: unknown = JSON.parse(rawValue);
    if (!Array.isArray(parsed)) return [];
    return Array.from(new Set(parsed.filter((value): value is string => typeof value === "string" && value.length > 0)));
  } catch {
    return [];
  }
};

export const saveFollowedPlaceIds = (
  placeIds: string[],
  storage: StorageLike | null = defaultStorage,
): boolean => {
  if (!storage) return false;

  try {
    storage.setItem(FOLLOWED_PLACES_STORAGE_KEY, JSON.stringify(Array.from(new Set(placeIds))));
    return true;
  } catch {
    return false;
  }
};

export const toggleFollowedPlaceId = (placeIds: string[], placeId: string): { placeIds: string[]; followed: boolean } => {
  if (placeIds.includes(placeId)) {
    return { placeIds: placeIds.filter((currentId) => currentId !== placeId), followed: false };
  }
  return { placeIds: [...placeIds, placeId], followed: true };
};
